import { Grid } from "@sidelinesports/fan-design-system";
import { MessageItem } from "./components/MessageItem.tsx";
import { ScoringEventItem } from "./components/ScoringEventItem.tsx";
import { useLiveFeedEntries } from "./hooks/use-live-feed-entries.ts";

export const LiveFeedMessages = () => {
  const { entries } = useLiveFeedEntries();

  return (
    <Grid gap={24} px={16} pb={16}>
      {entries
        .filter((entry) => entry.kind !== "FEATURED_MESSAGE")
        .map((entry) => {
          if (entry.kind === "SCORING_EVENT") {
            return <ScoringEventItem scoringEvent={entry} key={entry.id} />;
          }

          return <MessageItem message={entry} key={entry.id} />;
        })}
    </Grid>
  );
};
